import { FILTER_KEYS } from '@app/consts';
import {
    ArrayFilterProperty,
    ScalarFilterProperty,
    SearchFilters,
    StringFilterProperty,
} from '@app/models';

export const FILTER_CONFIG = {
    arrayFilters: {
        [FILTER_KEYS.PROPERTY_TYPE]: 'propertyType',
        [FILTER_KEYS.AMENITIES]: 'amenities',
        [FILTER_KEYS.PROVISION]: 'provision',
        [FILTER_KEYS.RESERVATION_FEATURES]: 'reservationFeatures',
    } as Record<string, keyof Pick<SearchFilters, ArrayFilterProperty>>,

    scalarFilters: {
        [FILTER_KEYS.RATING]: 'rating',
        [FILTER_KEYS.PRICE_FROM]: 'priceFrom',
        [FILTER_KEYS.PRICE_TO]: 'priceTo',
        [FILTER_KEYS.BEACH_DISTANCE]: 'beachDistance',
    } as Record<string, keyof Pick<SearchFilters, ScalarFilterProperty>>,

    stringFilters: {
        [FILTER_KEYS.ONLINE_BOOKING]: 'onlineBooking',
    } as Record<string, keyof Pick<SearchFilters, StringFilterProperty>>,

    defaults: {
        arrayDefaults: {
            propertyType: [] as string[],
            amenities: [] as string[],
            provision: [] as string[],
            reservationFeatures: [] as string[],
        },

        scalarDefaults: {
            rating: null,
            priceFrom: null,
            priceTo: null,
            beachDistance: null,
        },

        stringDefaults: {
            onlineBooking: null,
        },

        getDefaultFilters(): SearchFilters {
            const defaultFilters = {
                ...this.arrayDefaults,
                ...this.scalarDefaults,
                ...this.stringDefaults,
            };

            return defaultFilters as SearchFilters;
        },
    },

    get arrayFilterKeys() {
        return Object.keys(this.arrayFilters);
    },

    get scalarFilterKeys() {
        return Object.keys(this.scalarFilters);
    },

    get stringFilterKeys() {
        return Object.keys(this.stringFilters);
    },
};
